/**LIBRARY IMPORT */
import React from "react";


/**COMPONENTS IMPORT */
import PageHero from "../Components/PageHero";

const BlogDetail=()=>{

    return(
        <>
         {/**HERO SECTION */}
        <PageHero heading={"Smart Strategies for Faster Growth"}/>
        </>
    )
}

export default BlogDetail;